import React, {useEffect, useState} from 'react'
import {Alert, Button, Checkbox, DatePicker, Form, Input, message, Modal, Radio, Switch} from 'antd'
import {useNavigate, useRevalidator} from 'react-router-dom'
import {PostgrestError} from '@supabase/supabase-js'
import dayjs, {Dayjs} from 'dayjs'
import {useIntl} from 'react-intl'
import {instance as userService} from '../../services/UserService'
import {emailRegexp} from './util'

export function LoginForm() {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [isSubmitting, setSubmitting] = useState(false)
  const revalidator = useRevalidator()
  const [messageApi, contextHolder] = message.useMessage()

  const [globalError, setGlobalError] = useState<string | null>()

  const intl = useIntl()

  const validateMessages = {
    required: intl.formatMessage({id: 'fieldIsRequired'}, {field: '${label}'}),

    types: {
      email: intl.formatMessage({id: 'emailIsIncorrect'}),
    },
  }

  return (
    <div style={{width: '100%'}}>
      {contextHolder}

      {globalError && (
        <div>
          <Alert
            type="error"
            showIcon
            closable
            onClose={() => setGlobalError(null)}
            message={intl.formatMessage({id: 'errorDuringLogin'})}
            description={globalError}
          />
        </div>
      )}

      <Form
        form={form}
        layout="vertical"
        validateMessages={validateMessages}
        onFinish={async (formState) => {
          setSubmitting(true)
          const result = await userService.signInEmailPassword(formState.email, formState.password)
          setSubmitting(false)
          if (result.success) {
            revalidator.revalidate()
            navigate('/home')
          } else {
            setGlobalError(result.error?.message)
          }
        }}
      >
        <Form.Item
          name="email"
          label={intl.formatMessage({id: 'email'})}
          rules={[{required: true, type: 'email'}]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="password"
          label={intl.formatMessage({id: 'password'})}
          rules={[{required: true}]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" size="large" type="primary" style={{width: '100%'}}>
            {intl.formatMessage({id: 'continue'})}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
